import {
  CreateTagMappingForm,
  TagMappingDto,
  UpdateTagMappingForm,
  MatchingStrategy
} from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import { validateRequired } from "@fidget/common/utils/validatorsFormState";
import {
  ExistingMappingFormFields,
  ExistingMappingFormType,
  NewMappingFormFields,
  NewMappingFormType
} from "./types";

export const mapTagMappingToForm = (mapping: TagMappingDto): ExistingMappingFormType => {
  return new FormState<ExistingMappingFormFields>({
    id: new FieldState(mapping.id),
    tag: new FormState({
      id: new FieldState(mapping.tag.id),
      tag: new FieldState(mapping.tag.tag),
      enabled: new FieldState(mapping.tag.enabled)
    }),
    urlPattern: new FieldState(mapping.urlPattern).validators(validateRequired),
    matchingStrategy: new FieldState<string>(mapping.matchingStrategy).validators(validateRequired),
    enabled: new FieldState(mapping.enabled)
  });
};

export const createNewTagMappingForm = (): NewMappingFormType => {
  return new FormState<NewMappingFormFields>({
    tagId: new FieldState(""),
    urlPattern: new FieldState("").validators(validateRequired),
    matchingStrategy: new FieldState("").validators(validateRequired)
  });
};

export const copyExistingMappingForm = (form: ExistingMappingFormType): ExistingMappingFormType => {
  return new FormState<ExistingMappingFormFields>({
    id: new FieldState(form.$.id.$),
    tag: new FormState({
      id: new FieldState(form.$.tag.$.id.$),
      tag: new FieldState(form.$.tag.$.tag.$),
      enabled: new FieldState(form.$.tag.$.enabled.$)
    }),
    urlPattern: new FieldState(form.$.urlPattern.$).validators(validateRequired),
    matchingStrategy: new FieldState(form.$.matchingStrategy.$).validators(validateRequired),
    enabled: new FieldState(form.$.enabled.$)
  });
};

export const mapNewFormToCreateForm = (form: NewMappingFormType): CreateTagMappingForm => {
  return {
    tagId: form.$.tagId.$,
    urlPattern: form.$.urlPattern.$,
    matchingStrategy: form.$.matchingStrategy.$ as MatchingStrategy
  };
};

export const mapExistingFormToUpdateForm = (
  form: ExistingMappingFormType
): UpdateTagMappingForm => {
  return {
    urlPattern: form.$.urlPattern.$,
    tagId: form.$.tag.$.id.$,
    matchingStrategy: form.$.matchingStrategy.$ as MatchingStrategy,
    enabled: form.$.enabled.$
  };
};
